export default __webpack_public_path__ + "static/media/down-2.2b6f74e7.svg";